import StartAudioContext from 'startaudiocontext';
import bowser from 'bowser';

import {forceToResumeAudioContext} from '@repo/scratch-mod';

let AUDIO_CONTEXT;

if (!bowser.msie) {
    /**
     * AudioContext can be initialized only when user interaction event happens
     */
    const event =
        typeof document.ontouchstart === 'undefined' ?
            'mousedown' :
            'touchstart';
    const initAudioContext = () => {
        document.removeEventListener(event, initAudioContext);
        AUDIO_CONTEXT = new (window.AudioContext ||
            window.webkitAudioContext)();
        StartAudioContext(AUDIO_CONTEXT);

        forceToResumeAudioContext(AUDIO_CONTEXT);
    };
    document.addEventListener(event, initAudioContext);
}

/**
 * Wrap browser AudioContext because we shouldn't create more than one
 * @return {AudioContext} The singleton AudioContext
 */
export default function () {
    // [TOIODO-725] fix crash issue by using mouse instead of touch.
    if (!AUDIO_CONTEXT) {
        AUDIO_CONTEXT = new (window.AudioContext || window.webkitAudioContext)();
        StartAudioContext(AUDIO_CONTEXT);

        forceToResumeAudioContext(AUDIO_CONTEXT);
    }

    return AUDIO_CONTEXT
}
